import axios from "axios";
import { useEffect, useState } from "react";
import NFTCard from "./NFTCard.component";
import Button from "@components/common/Button.component";
import { marketplaceCraft, marketplaceGangstaBet } from "@misc/Links";
import { LOGOS } from "@constants/images";

const TopSold = ({ displayCount = 5 }) => {
  const [topSoldGangstas, setTopSoldGangstas] = useState<any>([]);

  useEffect(() => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const api_endpoint_recent_sold = "/recents/sold";
    axios.get(base_url + api_endpoint_recent_sold).then((res) => {
      const top_sold_nft_info = res.data.recently_sold.tokens.slice(
        0,
        displayCount
      );
      setTopSoldGangstas(top_sold_nft_info);
    });
  }, []);

  return (
    <div className="gangstaverse-land-bg">
      <div className="gangstaverse-stat-wrapper topsold-gutter">
        <div className="gangstaverse-land-heading-top-sold">
          Recently Sold GangstaBet NFTs
        </div>

        <div className="nft__card__wrapper">
          {topSoldGangstas.map((stat: any, index: any) => (
            <NFTCard
              image={stat?.token_uri}
              name={stat.token_name}
              class_type={stat.class_type}
              price={stat.total_price_sold.toFixed(2)}
              key={index}
              id={stat._id}
            />
          ))}
        </div>

        <div className="marketplace-explore">
          <h6>See more on</h6>
          <div className="marketplace">
            <img
              className="gangstabet-hat"
              src={LOGOS.GANGSTABET_HAT}
              alt="gangstbet-hat"
              width={60}
              onClick={() => {
                window.open(marketplaceGangstaBet, "_blank");
              }}
            />
            <img
              onClick={() => {
                window.open(marketplaceCraft, "_blank");
              }}
              className="craft"
              width={60}
              src={LOGOS.CRAFT}
              alt="craft"
            />
          </div>
          {/* <Button
            onClick={() => {
              window.open(marketplaceGangstaBet, "_blank");
            }}
            className="marketplace-icon"
          >
            Gangstabet
          </Button>
          <Button
            onClick={() => {
              window.open(marketplaceCraft, "_blank");
            }}
            className="marketplace-craft"
          >
            Craft
          </Button> */}
        </div>

        {/* <img className="gangstaverse-land-image" src={LAND.LANDBG} /> */}
      </div>
    </div>
  );
};

export default TopSold;
